const productionTypes = {
	INTERNAL: null,
	EXTERNAL: "external",
	BACKLIST: "backlist",
	SUBCONTRACT: "subcontract",
};

export default productionTypes;
